import script from "./wysiwyg.vue?vue&type=script&setup=true&lang=js"
export * from "./wysiwyg.vue?vue&type=script&setup=true&lang=js"

import "./wysiwyg.vue?vue&type=style&index=0&id=01cd5e72&scoped=true&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-01cd5e72"]])

export default __exports__